import { Component, OnInit, ViewChild } from '@angular/core';
import * as CanvasJS from '../../assets/canvasjs.min';
import { JwtHelper } from 'angular2-jwt';
import { Router } from '@angular/router'

//Services
import { ListUserService } from '../shared/services/list-user.service'
import { TypeService } from '../shared/services/type.service'
import { ActivityTypeService } from '../shared/services/activity-type.service'
import { OpportunityTypeService } from '../shared/services/opportunity-type.service'
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { UserService } from '../shared/services/user/user.service';
import { Type } from '@angular/compiler/src/output/output_ast';
import { DashboardDetailPopupComponent } from './dashboard-detail-popup/dashboard-detail-popup.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  @ViewChild(DashboardDetailPopupComponent) popupModal: DashboardDetailPopupComponent

  queryData: any = {}
  users: any = []
  selectedUsers: any = []
  graphCount: number = 0
  currentUser: any = {}
  chartType: any = ''

  constructor(
    private spinner: Ng4LoadingSpinnerService,
    private userService: UserService,
    private jwtHelper: JwtHelper,
    private opptyTypeService: OpportunityTypeService,
    private activitytypeService: ActivityTypeService,
    private typeService: TypeService,
    private listUserService: ListUserService,
    private router: Router
  ) { }

  clearFilters() {
    this.selectedUsers = []
    sessionStorage.removeItem('dashboardFilters')
    this.users.map(u => {
      if (u.user_id == this.currentUser['userId']) {
        this.selectedUsers.push(u)
      }
    })
    this.queryData['sales']['format'] = 'monthly'
    this.queryData['sales']['chartType'] = 'stackedColumn'

    this.queryData['opportunities']['format'] = 'monthly'
    this.queryData['opportunities']['chartType'] = 'splineArea'

    this.queryData['new_opportunities']['format'] = 'monthly'
    this.queryData['new_opportunities']['chartType'] = 'stackedColumn'

    this.queryData['activities']['format'] = 'today'
    this.queryData['activities']['chartType'] = 'stackedColumn'

    this.queryData['potential']['chartType'] = 'splineArea'
    this.queryData['potential']['resultType'] = 'price'
    this.callAllGraphs()
  }

  ngOnInit() {
    this.opptyTypeService.getAllOpptyTypes();
    this.typeService.getAllTypes();
    this.activitytypeService.getAllActTypes();
    this.listUserService.getUserList()
    this.queryData['sales'] = {}
    this.queryData['potential'] = {}
    this.queryData['opportunities'] = {}
    this.queryData['new_opportunities'] = {}
    this.queryData['activities'] = {}
    this.userService.getJobprocess().subscribe(res => {
      sessionStorage.setItem('jobprocess', JSON.stringify(res['data']));
      this.queryData['activities']['activity_job_status_id'] = JSON.parse(sessionStorage.getItem('jobprocess'))
    });


    this.currentUser = this.jwtHelper.decodeToken(JSON.parse(sessionStorage.getItem('currentUser')).token)

    this.getUsers()
  }

  callAllGraphs() {
    this.getSalesData()
    this.getPotentialSalesData()
    this.getOpportunitiesData()
    this.getNewOpportunitiesData()
    this.getActivitiesData()
  }

  triggerAll() {
    sessionStorage.setItem('dashboardFilters', JSON.stringify({ users: this.selectedUsers, chart: this.queryData['sales']['chartType'] }))
    this.callAllGraphs()
  }

  getUsers() {
    this.userService.getAllUsersWithDesignation().subscribe(result => {
      this.spinner.show()
      this.users = result['data'].reduce((unique, o) => {
        if (!unique.some(obj => obj.user_id === o.user_id) && o.designation === 'All') {
          unique.push(o);
        }
        return unique;
      }, []);

      if (sessionStorage.getItem('dashboardFilters')) {
        let temp = JSON.parse(sessionStorage.getItem('dashboardFilters'))
        this.selectedUsers = temp['users']
        this.queryData['sales']['chartType'] = temp['chart']
      } else {
        this.users.map(u => {
          if (u.user_id == this.currentUser['userId']) {
            this.selectedUsers.push(u)
          }
        })

        //TEMPORARY FIX
        if(this.selectedUsers.length == 0){
          let quickFix = this.users.find(i => i.user_id === 3)
          this.selectedUsers.push(quickFix)
        }
        //END
        
        this.queryData['sales']['chartType'] = 'splineArea'
      }

      //Set format for report
      this.queryData['sales']['format'] = 'monthly'
      this.queryData['sales']['chartType'] = 'stackedColumn'

      this.queryData['opportunities']['format'] = 'monthly'
      this.queryData['opportunities']['chartType'] = 'splineArea'

      this.queryData['new_opportunities']['format'] = 'monthly'
      this.queryData['new_opportunities']['chartType'] = 'stackedColumn'

      this.queryData['activities']['format'] = 'today'
      this.queryData['activities']['chartType'] = 'stackedColumn'

      this.queryData['potential']['chartType'] = 'splineArea'
      this.queryData['potential']['resultType'] = 'price'
      this.callAllGraphs()
    }, error => {
      console.log(error)
      this.spinner.hide()
    })
  }

  generateColumnsFromDateType(format, type) {
    let cols = []
    let monthNames = [
      { label: "Jan", date: '31', month: '01' },
      { label: "Feb", date: '28', month: '02' },
      { label: "Mar", date: '31', month: '03' },
      { label: "Apr", date: '30', month: '04' },
      { label: "May", date: '31', month: '05' },
      { label: "Jun", date: '30', month: '06' },
      { label: "Jul", date: '31', month: '07' },
      { label: "Aug", date: '31', month: '08' },
      { label: "Sep", date: '30', month: '09' },
      { label: "Oct", date: '31', month: '10' },
      { label: "Nov", date: '30', month: '11' },
      { label: "Dec", date: '31', month: '12' }
    ]

    let date = new Date()

    if (type != 'potential' && type != 'activities') {
      if (format == 'monthly') {
        var month = date.getMonth()
        let labelIndex = month
        for (let i = 0; i <= 12; i++) {
          let temp = {}
          let sm = month - i
          let startDate = new Date(date.getFullYear(), sm, 1);
          let endDate = new Date(date.getFullYear(), sm + 1, 0);

          temp['label'] = `${monthNames[labelIndex].label} - ${startDate.getFullYear()}`
          temp['date'] = {
            start_date: this.formatDate(startDate, 'start'),
            end_date: this.formatDate(endDate, 'end'),
          }
          cols.push(temp)
          labelIndex--
          if (labelIndex == -1) labelIndex = 11
        }
      } else if (format == 'quarterly') {
        var quarter = Math.floor((date.getMonth() / 3))
        let labelIndex = quarter + 1
        for (let i = 0; i <= 12; i++) {
          let temp = {}
          let sm = (quarter * 3) - (3 * i)
          let startDate = new Date(date.getFullYear(), sm, 1);
          let endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);

          temp['label'] = `Quarter ${labelIndex} - ${startDate.getFullYear()}`
          temp['date'] = {
            start_date: this.formatDate(startDate, 'start'),
            end_date: this.formatDate(endDate, 'end'),
          }
          cols.push(temp)
          labelIndex--
          if (labelIndex == 0) labelIndex = 4
        }
      } else {
        let year = date.getFullYear()
        for (let i = 0; i <= 12; i++) {
          let temp = {}
          let startDate = new Date(year, 0, 1);
          let endDate = new Date(year, 12, 0);

          temp['label'] = `${year}`
          temp['date'] = {
            start_date: this.formatDate(startDate, 'start'),
            end_date: this.formatDate(endDate, 'end'),
          }
          cols.push(temp)
          year--
        }
      }

    } else if (type != 'activities') {
      var month = date.getMonth()
      let labelIndex = date.getMonth() - 1
      for (let i = -1; i <= 3; i++) {
        let temp = {}
        let sm = month + i
        let startDate = new Date(date.getFullYear(), sm, 1);
        let endDate = new Date(date.getFullYear(), sm + 1, 0);
        if(labelIndex >= 0){
          temp['label'] = `${monthNames[labelIndex].label} - ${startDate.getFullYear()}`
          temp['date'] = {
            start_date: this.formatDate(startDate, 'start'),
            end_date: this.formatDate(endDate, 'end'),
          }
          cols.push(temp)
        }
        labelIndex++
        if (labelIndex == 12) labelIndex = 0
      }
    } else {
      var month = date.getMonth()
      let temp = {}
      let sm = month
      if (format == 'past') {
        let startDate = new Date(date.getFullYear(), sm - 5, 1);
        let endDate = new Date(date.getFullYear(), sm, date.getDate() - 1);

        temp['date'] = {
          start_date: this.formatExactDate(startDate),
          end_date: this.formatExactDate(endDate),
        }
        cols.push(temp)
      } else if(format == 'today') {
        let startDate = new Date(date.getFullYear(), sm - 5, 1);
        let endDate = new Date(date.getFullYear(), sm, date.getDate());

        temp['date'] = {
          start_date: this.formatExactDate(startDate),
          end_date: this.formatExactDate(endDate),
        }
        cols.push(temp)
      } else if(format == 'pastTomorrow') {
        let startDate = new Date(date.getFullYear(), sm - 5, 1);
        let endDate = new Date(date.getFullYear(), sm, date.getDate() + 1);

        temp['date'] = {
          start_date: this.formatExactDate(startDate),
          end_date: this.formatExactDate(endDate),
        }
        cols.push(temp)
      } else if(format == 'tomorrow') {
        let startDate = new Date(date.getFullYear(), sm, date.getDate() + 1);
        let endDate = new Date(date.getFullYear(), sm, date.getDate() + 1);

        temp['date'] = {
          start_date: this.formatExactDate(startDate),
          end_date: this.formatExactDate(endDate),
        }
        cols.push(temp)
      } else if(format == 'all') {
        let startDate = new Date(date.getFullYear(), sm - 5, 1);
        let endDate = new Date(date.getFullYear(), sm + 6, +monthNames[sm+6].date);

        temp['date'] = {
          start_date: this.formatExactDate(startDate),
          end_date: this.formatExactDate(endDate),
        }
        cols.push(temp)
      }
    }
    return cols
  }

  formatExactDate(d) {
    let date = new Date(d)
    let m = date.getMonth() + 1, da = date.getDate()
    let month = (m < 10) ? `0${m}` : m
    let day = (da < 10) ? `0${da}` : da
    return `${date.getFullYear()}-${month}-${day}`
  }

  formatDate(d, type) {
    let date = new Date(d)
    let isLeapYear = (date.getFullYear() % 100 === 0) ? (date.getFullYear() % 400 === 0) : (date.getFullYear() % 4 === 0)
    let monthNames = [
      { label: "Jan", date: '31', month: '01' },
      { label: "Feb", date: '28', month: '02' },
      { label: "Mar", date: '31', month: '03' },
      { label: "Apr", date: '30', month: '04' },
      { label: "May", date: '31', month: '05' },
      { label: "Jun", date: '30', month: '06' },
      { label: "Jul", date: '31', month: '07' },
      { label: "Aug", date: '31', month: '08' },
      { label: "Sep", date: '30', month: '09' },
      { label: "Oct", date: '31', month: '10' },
      { label: "Nov", date: '30', month: '11' },
      { label: "Dec", date: '31', month: '12' }
    ]

    if (type == 'start') {
      return `${date.getFullYear()}-${monthNames[date.getMonth()].month}-01`
    } else {
      if (date.getMonth() == 1 && isLeapYear) {
        return `${date.getFullYear()}-${monthNames[date.getMonth()].month}-29`
      } else {
        return `${date.getFullYear()}-${monthNames[date.getMonth()].month}-${monthNames[date.getMonth()].date}`
      }
    }
  }

  formQueryData(value, type, report) {
    this.queryData[report][type] = value
    if (report == 'sales') {
      this.getSalesData()
    } else if (report == 'opportunities') {
      this.getOpportunitiesData()
    } else if (report == 'new_opportunities') {
      this.getNewOpportunitiesData()
    } else if (report == 'activities') {
      this.getActivitiesData()
    } else if(report == 'potential'){
      this.getPotentialSalesData()
    }
  }

  getSalesData() {
    let graphData = []
    this.queryData['sales']['cols'] = this.generateColumnsFromDateType(this.queryData['sales']['format'], 'sales').reverse()

    let q = {
      users: this.selectedUsers,
      cols: this.queryData['sales']['cols']
    }

    if (this.selectedUsers && this.selectedUsers.length > 0) {
      this.userService.getUserSales(q).subscribe(response => {
        for (let key in response['data']) {
          let temp = response['data'][key].reduce((unique, o) => {
            if (!unique.some(obj => obj.oppty_id === o.oppty_id)) {
              unique.push(o);
            }
            return unique;
          }, []);
          let row = {}
          row['y'] = temp.reduce((a, b) => a + b.price, 0)
          row['label'] = key
          graphData.push(row)
        }
        let chart = new CanvasJS.Chart("salesChart", {
          animationEnabled: true,
          exportEnabled: false,
          title: {
            text: ""
          },
          data: [
            {
              click: (e) => {
                let data = {
                  api: 'sales',
                  user: this.selectedUsers,
                  cols: [this.queryData['sales']['cols'].find(i => i.label === e.dataPoint.label)]
                }
                this.popupModal.showModal(data)
              },
              type: this.queryData['sales']['chartType'],
              dataPoints: graphData
            },
          ]
        });

        chart.render();

        this.graphCount++
        if (this.graphCount >= 5) this.spinner.hide()
      }, error => {
        console.log(error)
      })
    }
  }

  getPotentialSalesData() {
    let graphData = {}
    graphData['high'] = []
    graphData['medium'] = []
    graphData['low'] = []
    this.queryData['potential']['cols'] = this.generateColumnsFromDateType(this.queryData['potential']['format'], 'potential')

    let q = {
      users: this.selectedUsers,
      cols: this.queryData['potential']['cols']
    }

    if (this.selectedUsers && this.selectedUsers.length > 0) {
      this.userService.getPotentialSales(q).subscribe(response => {
        let filtered = []
        for (let key in response['data']) {
          let temp = response['data'][key].reduce((unique, o) => {
            if (!unique.some(obj => obj.oppty_id === o.oppty_id)) {
              unique.push(o);
            }
            return unique;
          }, []);

          let high = temp.filter(i => i.probability == 'high')
          let medium = temp.filter(i => i.probability == 'medium')
          let low = temp.filter(i => i.probability == 'low')

          if(this.queryData['potential']['resultType'] == 'price'){
            let row1 = {}
            row1['y'] = high.reduce((a, b) => a + b.price, 0)
            row1['label'] = key
            graphData['high'].push(row1)

            let row2 = {}
            row2['y'] = medium.reduce((a, b) => a + b.price, 0)
            row2['label'] = key
            graphData['medium'].push(row2)
  
            let row3 = {}
            row3['y'] = low.reduce((a, b) => a + b.price, 0)
            row3['label'] = key
            graphData['low'].push(row3)    
          } else {
            let row1 = {}
            row1['y'] = high.length
            row1['label'] = key
            graphData['high'].push(row1)

            let row2 = {}
            row2['y'] = medium.length
            row2['label'] = key
            graphData['medium'].push(row2)
  
            let row3 = {}
            row3['y'] = low.length
            row3['label'] = key
            graphData['low'].push(row3)
          }
        }

        let chart = new CanvasJS.Chart("potentialSalesChart", {
          animationEnabled: true,
          exportEnabled: false,
          title: {
            text: ""
          },
          data: [
            {
              click: (e) => {
                let data = {
                  api: 'potential',
                  type: 'high',
                  user: this.selectedUsers,
                  cols: [this.queryData['potential']['cols'].find(i => i.label === e.dataPoint.label)]
                }
                this.popupModal.showModal(data)
              },
              type: this.queryData['potential']['chartType'],
              name: "High",
              showInLegend: true,
              dataPoints: graphData['high']
            },
            {
              click: (e) => {
                let data = {
                  api: 'potential',
                  type: 'medium',
                  user: this.selectedUsers,
                  cols: [this.queryData['potential']['cols'].find(i => i.label === e.dataPoint.label)]
                }
                this.popupModal.showModal(data)
              },
              type: this.queryData['potential']['chartType'],
              name: "Medium",
              showInLegend: true,
              dataPoints: graphData['medium']
            },
            {
              click: (e) => {
                let data = {
                  api: 'potential',
                  type: 'low',
                  user: this.selectedUsers,
                  cols: [this.queryData['potential']['cols'].find(i => i.label === e.dataPoint.label)]
                }
                this.popupModal.showModal(data)
              },
              type: this.queryData['potential']['chartType'],
              name: "Low",
              showInLegend: true,
              dataPoints: graphData['low']
            }
          ]
        });

        chart.render();

        this.graphCount++
        if (this.graphCount >= 5) this.spinner.hide()
      }, error => {
        console.log(error)
      })
    }
  }

  getOpportunitiesData() {
    let graphData = {}
    graphData['won'] = []
    graphData['lost'] = []
    this.queryData['opportunities']['cols'] = this.generateColumnsFromDateType(this.queryData['opportunities']['format'], 'opportunities').reverse()

    let q = {
      users: this.selectedUsers,
      cols: this.queryData['opportunities']['cols']
    }

    if (this.selectedUsers && this.selectedUsers.length > 0) {
      this.userService.getOpportunities(q).subscribe(response => {
        let filtered = []
        for (let key in response['data']) {
          let temp = response['data'][key].reduce((unique, o) => {
            if (!unique.some(obj => obj.oppty_id === o.oppty_id)) {
              unique.push(o);
            }
            return unique;
          }, []);

          let row1 = {}
          row1['y'] = temp.filter(i => i.status == 'won').length
          row1['label'] = key
          graphData['won'].push(row1)

          let row2 = {}
          row2['y'] = temp.filter(i => i.status == 'lost').length
          row2['label'] = key
          graphData['lost'].push(row2)

        }

        let chart = new CanvasJS.Chart("opportunitiesChart", {
          animationEnabled: true,
          exportEnabled: false,
          title: {
            text: ""
          },
          data: [
            {
              click: (e) => {
                let data = {
                  api: 'won_lost',
                  type: 'won',
                  user: this.selectedUsers,
                  cols: [this.queryData['opportunities']['cols'].find(i => i.label === e.dataPoint.label)]
                }
                this.popupModal.showModal(data)
              },
              type: this.queryData['opportunities']['chartType'],
              name: "Won",
              showInLegend: true,
              dataPoints: graphData['won']
            },
            {
              click: (e) => {
                let data = {
                  api: 'won_lost',
                  type: 'lost',
                  user: this.selectedUsers,
                  cols: [this.queryData['opportunities']['cols'].find(i => i.label === e.dataPoint.label)]
                }
                this.popupModal.showModal(data)
              },
              type: this.queryData['opportunities']['chartType'],
              name: "Lost",
              showInLegend: true,
              dataPoints: graphData['lost']
            }
          ]
        });

        chart.render();

        this.graphCount++
        if (this.graphCount >= 5) this.spinner.hide()
      }, error => {
        console.log(error)
      })
    }
  }

  getNewOpportunitiesData() {
    let graphData = []
    this.queryData['new_opportunities']['cols'] = this.generateColumnsFromDateType(this.queryData['new_opportunities']['format'], 'new_opportunities').reverse()

    let q = {
      users: this.selectedUsers,
      cols: this.queryData['new_opportunities']['cols']
    }

    if (this.selectedUsers && this.selectedUsers.length > 0) {
      this.userService.getNewOpportunities(q).subscribe(response => {
        for (let key in response['data']) {
          let temp = response['data'][key].reduce((unique, o) => {
            if (!unique.some(obj => obj.oppty_id === o.oppty_id)) {
              unique.push(o);
            }
            return unique;
          }, []);
          let row = {}
          row['y'] = temp.length
          row['label'] = key
          graphData.push(row)
        }
        let chart = new CanvasJS.Chart("newOpportunitiesChart", {
          animationEnabled: true,
          exportEnabled: false,
          title: {
            text: ""
          },
          data: [
            {
              click: (e) => {
                let data = {
                  api: 'new_opportunities',
                  users: this.selectedUsers,
                  cols: [this.queryData['new_opportunities']['cols'].find(i => i.label === e.dataPoint.label)]
                }
                this.popupModal.showModal(data)
              },
              type: this.queryData['new_opportunities']['chartType'],
              dataPoints: graphData
            },
          ]
        });

        chart.render();

        this.graphCount++
        if (this.graphCount >= 5) this.spinner.hide()
      }, error => {
        console.log(error)
      })
    }
  }

  getActivitiesData() {
    let graphData = []

    this.queryData['activities']['cols'] = this.generateColumnsFromDateType(this.queryData['activities']['format'], 'activities').reverse()

    let q = {
      users: this.selectedUsers,
      cols: this.queryData['activities']['cols'],
      activity_job_status_id: this.queryData['activities']['activity_job_status_id']
    }

    if (this.selectedUsers && this.selectedUsers.length > 0) {
      this.userService.getActivities(q).subscribe(response => {
        let temp = response['data']

        this.queryData['activities']['activity_job_status_id'].map(i => {
          let row = {}
          row['y'] = temp.filter(l => l.jobStatusID == i.oppty_job_process_id).length
          row['label'] = i.name
          graphData.push(row)
        })

        let row = {}
        row['y'] = temp.length
        row['label'] = 'All'
        graphData.push(row)

        let chart = new CanvasJS.Chart("activitiesChart", {
          animationEnabled: true,
          exportEnabled: false,
          title: {
            text: ""
          },
          data: [
            {
              click: (e) => {
                let activityQueryData = {}
                if(sessionStorage.getItem('activity_list_query')){
                  activityQueryData = JSON.parse(sessionStorage.getItem('activity_list_query'))
                }
                if(this.queryData['activities']['format'] == 'today'){
                  sessionStorage.setItem('ACT_DATE_RANGE', 'past_today')
                } else if(this.queryData['activities']['format'] == 'pastTomorrow'){
                  sessionStorage.setItem('ACT_DATE_RANGE', 'past_today_tomorrow')
                } else {
                  sessionStorage.setItem('ACT_DATE_RANGE', this.queryData['activities']['format'])
                }
                
                let selUsers = []
                this.selectedUsers.map(u => {
                  selUsers.push(u.user_id)
                })

                if(e['dataPoint'].label != 'All'){
                  sessionStorage.setItem('ACT_REG', JSON.stringify([e['dataPoint'].x+1]))
                  sessionStorage.setItem('ACTIVITY_JOB_STATUS_NAME', JSON.stringify([e['dataPoint'].label]))
                  activityQueryData['activity_job_status_id'] = [ (e['dataPoint'].x)+1 ]
                } else {
                  let ids = [], names = []
                  this.queryData['activities']['activity_job_status_id'].map(i => {
                    ids.push(i.oppty_job_process_id)
                    names.push(i.name)
                  })
                  activityQueryData['activity_job_status_id'] = ids
                  sessionStorage.setItem('ACT_REG', JSON.stringify(ids))
                  sessionStorage.setItem('ACTIVITY_JOB_STATUS_NAME', JSON.stringify(names))
  
                }
                sessionStorage.setItem('ACT_CREATED_FOR', JSON.stringify(selUsers))
                activityQueryData['created_for'] = selUsers                
                sessionStorage.setItem('activity_list_query', JSON.stringify(activityQueryData))
                this.router.navigate(['/activities'])
              },
              type: this.queryData['activities']['chartType'],
              dataPoints: graphData
            }
          ]
        });

        chart.render();

        this.graphCount++
        if (this.graphCount >= 5) this.spinner.hide()
      }, error => {
        console.log(error)
      })
    }

  }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts